const API_BASE_URL = "https://goodplanet.crm12.dynamics.com/api/data/v9.1";
export default API_BASE_URL;